var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 34,
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    "aria-hidden": "true",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hourglass_svg__a)",
    d: "M23.959 10.709Q25 8.329 25 5.043V.027A.027.027 0 0 0 24.973 0H.883A.886.886 0 0 0 0 .889v4.154q0 3.286 1.042 5.666 1.09 2.437 3.57 4.306l1.711 1.269a.892.892 0 0 1 0 1.431l-1.712 1.271q-2.48 1.868-3.57 4.305Q0 25.671 0 28.957v4.99c0 .029.024.053.053.053H24.88a.12.12 0 0 0 .119-.12v-4.923q0-3.286-1.041-5.666-1.09-2.437-3.57-4.305l-1.711-1.27a.892.892 0 0 1 0-1.431l1.711-1.269q2.48-1.87 3.571-4.307m-11.974 2.769a.875.875 0 0 0 1.031 0l3.506-2.543q1.387-1.019 2.032-2.209.442-.841.556-2.059c.045-.489-.356-.888-.843-.888H6.733c-.487 0-.888.399-.842.888q.113 1.217.555 2.058.645 1.191 2.033 2.21zm1.03 7.044a.875.875 0 0 0-1.031 0l-3.505 2.543q-1.39 1.02-2.033 2.21-.442.841-.556 2.059c-.046.488.356.887.843.887h11.533c.487 0 .889-.399.843-.887q-.113-1.218-.555-2.059-.645-1.19-2.033-2.21z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hourglass_svg__a",
    x2: 1,
    gradientTransform: "matrix(0 34 -33.7589 0 12.5 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c1"
  })))));
};
export default SvgHourglass;